const fileUtils = {

	baixarArquivo(arquivoBase64, nomeArquivo) {
		const byteCharacters = this.base64ToArrayBuffer(arquivoBase64);
		this.saveByteArray([ byteCharacters ], nomeArquivo);
	},
	base64ToArrayBuffer(base64) {
		const binaryString = window.atob(base64);
		const binaryLen = binaryString.length;
		const bytes = new Uint8Array(binaryLen);
		for (let i = 0; i < binaryLen; i++) {
			const ascii = binaryString.charCodeAt(i);
			bytes[i] = ascii;
		}
		return bytes;
	},
	saveByteArray(data, nomeArquivo) {
		const a = document.createElement("a");
		document.body.appendChild(a);
		a.style = "display: none";

		let tipoArquivo = "";

		const extensao = nomeArquivo.slice(nomeArquivo.lastIndexOf(".") + 1, nomeArquivo.length);
		if (extensao == "pdf") {
			tipoArquivo = "application/pdf";
		} else if (extensao == "xls") {
			tipoArquivo = "application/vnd.ms-excel";
		} else if (extensao == "xlsx") {
			tipoArquivo = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
		} else {
			tipoArquivo = "application/octet-stream";
		}

		const blob = new Blob(data);
		const url = window.URL.createObjectURL(blob);
		a.href = url;
		a.download = nomeArquivo;
		a.click();
		window.URL.revokeObjectURL(url);
	},
	base64ToString(strBase64) {
		return atob(strBase64);
	},
};
export default fileUtils;



// WEBPACK FOOTER //
// ./src/utils/FileUtils.js